<template>
  <div>
    <div class="message-template">
      <el-row>
        <el-col :span="2">
          <el-button type="primary" @click="addTemplatesDialogVisible()">添加模板</el-button>
<!--      <el-button type="text" @click="pushLog()">查看推送记录</el-button>-->
        </el-col>
        <el-col :span="6">
          <el-select v-model="appid" @change="reloadList()" placeholder="请选择app">
            <el-option
                v-for="item in appid_data"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <template>
        <el-table
            height="650px"
            :data="temlateList"
            style="width: 100%;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
          <el-table-column
              prop="id"
              label="id"
              width="80">
          </el-table-column>
          <el-table-column
              prop="title"
              label="模板名称">
          </el-table-column>
          <el-table-column
              prop="template_id"
              label="模板id">
          </el-table-column>
          <el-table-column
              prop="scenes_name"
              label="模板别名">
          </el-table-column>
          <el-table-column
              prop="is_open"
              label="是否禁用"
              width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_open == 1" type="success">已启用</el-tag>
              <el-tag v-else type="danger">已禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="send_time_desc"
              label="发送时间"
              width="200">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="editTemplatesDialogVisible(scope.row)">编辑</el-button>
<!--              <el-button type="text" @click="subscriptionTableVisible(scope.row)">查看订阅</el-button>-->
              <el-button v-if="scope.row.tmpl_type=='nowSend'" type="text" @click="sendMsg(scope.row)">推送</el-button>
              <!--              <el-button-->
              <!--                  size="mini"-->
              <!--                  type="danger"-->
              <!--                  @click="handleDelete(scope.$index, scope.row)">删除-->
              <!--              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="content-center content-top-padded block" style="margin-top: 10px;">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="reloadList"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :total="total_count"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!--        <div v-for="row in temlateList" class="item" @click="toDetail(row)" :class="row.is_open ? 'succ-open-sms' : 'not-open-sms'" >-->
      <!--          <div class="item-title clearfix">{{row.title}} <i class="el-icon-arrow-right"></i></div>-->
      <!--          <div class="item-content" v-if="row.send_time_desc.value">{{row.send_time_desc.title}}{{row.send_time_desc.value}}分钟{{row.send_time_desc.end_title}}</div>-->
      <!--          <div class="item-content" v-else>{{row.send_time_desc.title}}</div>-->
      <!--          <div class="item-footer">-->
      <!--            <el-button type="default" size="small" v-if="row.is_open">启用中</el-button>-->
      <!--            <el-button type="default" size="small" v-else>未启用</el-button>-->
      <!--          </div>-->
      <!--        </div>-->
    </div>
    <el-dialog title="添加消息模版" size="tiny" :visible.sync="addTemplateDialog" :close-on-click-modal="false">
      <div class="section-body">
        <el-form label-width="125px" :model="addTemplate" ref="addTemplate">
          <el-form-item label="模板名称" :rules="{ required: true}">
            <el-input v-model="addTemplate.title" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label="模板id" :rules="{ required: true}">
            <el-input v-model="addTemplate.template_id" placeholder="请输入模板id"></el-input>
          </el-form-item>
          <el-form-item label="模板别名" :rules="{ required: true}">
            <el-input v-model="addTemplate.scenes_name" placeholder="请输入模板别名"></el-input>
          </el-form-item>
          <el-form-item label="消息类型" :rules="{ required: true}">
            <el-select v-model="addTemplate.tmpl_type" placeholder="请选择">
              <el-option
                  v-for="item in tmpl_type_data"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小程序app" :rules="{ required: true}">
            <el-select v-model="addTemplate.appid" placeholder="请选择app">
              <el-option
                  v-for="item in appid_data"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启">
            <el-switch v-model="addTemplate.is_open" active-value="1" inactive-value="0"
                       active-color="#13ce66"></el-switch>
          </el-form-item>
          <el-form-item label="发送时间点" :rules="{ required: true}">
            <el-date-picker
                v-model="addTemplate.send_time_desc"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模板内容">
            <div v-for="data in addTemplate.content" :key="data.column">
              <div style="margin-top:5px;">
                <el-input class="tempalteTag" v-model="data.keyName" placeholder="请输入键值名称例如thing1,thing2"></el-input>
                <el-input class="tempalteTag" v-model="data.keyValue" placeholder="请输入文案内容"></el-input>
                <el-button type="danger" plain @click="delAddKeyValue(data)">删除</el-button>
              </div>
            </div>
            <el-button @click="addTemplateTag">添加</el-button>
          </el-form-item>
          <el-form-item label="小程序跳转页面">
            <el-input v-model="addTemplate.page" placeholder="请输入跳转页面链接"></el-input>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="primary" @click="submitData">确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="小程序消息模版编辑" size="tiny" :visible.sync="editTemplateDialog" :close-on-click-modal="false">
      <div class="section-body">
        <el-form label-width="125px">
          <el-form-item label="模板名称" :rules="{ required: true}">
            <el-input v-model="editTemplate.title" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label="模板id" :rules="{ required: true}">
            <el-input v-model="editTemplate.template_id" placeholder="请输入模板id" disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="模板别名" :rules="{ required: true}">
            <el-input v-model="editTemplate.scenes_name" placeholder="请输入模板别名" disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="消息类型" :rules="{ required: true}">
            <el-select v-model="editTemplate.tmpl_type" placeholder="请选择">
              <el-option
                  v-for="item in tmpl_type_data"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小程序app" :rules="{ required: true}">
            <el-select v-model="editTemplate.appid" placeholder="请选择app">
              <el-option
                  v-for="item in appid_data"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启">
            <el-switch v-model="editTemplate.is_open" active-value="1" inactive-value="0"
                       active-color="#13ce66"></el-switch>
          </el-form-item>
          <el-form-item label="发送时间点" :rules="{ required: true}">
            <el-date-picker
                v-model="editTemplate.send_time_desc"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模板内容">
            <div v-for="data in editTemplate.content" :key="data.column">
              <div style="margin-top:5px;">
                <el-input class="tempalteTag" v-model="data.keyName" placeholder="请输入键值名称例如thing1,thing2"></el-input>
                <el-input class="tempalteTag" v-model="data.keyValue" placeholder="请输入文案内容"></el-input>
                <el-button type="danger" plain @click="delEditKeyValue(data)">删除</el-button>
              </div>
            </div>
            <el-button @click="editTemplateTag">添加</el-button>
          </el-form-item>
          <el-form-item label="小程序跳转页面">
            <el-input v-model="editTemplate.page" placeholder="请输入跳转页面链接"></el-input>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="primary" @click="editData">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
<!--    <el-dialog title="查看模板订阅信息" size="tiny" :visible.sync="subscriptionTableDialog"-->
<!--               :close-on-click-modal="false" style="padding:10px 20px">-->
<!--      <div class="sub_font_style">-->
<!--        <p>模板名称：{{ this.subscriptionData.template_name }}&nbsp;&nbsp;&nbsp;&nbsp;当前总订阅量：{{-->
<!--            this.subscriptionData.total_count-->
<!--          }}</p>-->
<!--      </div>-->
<!--      <el-table-->
<!--          :data="rowSubscriptionData"-->
<!--          style="width: 100%">-->
<!--        <el-table-column-->
<!--            prop="user_id"-->
<!--            label="用户id">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="open_id"-->
<!--            label="open_id">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="realname"-->
<!--            label="姓名">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="age"-->
<!--            label="年龄">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="template_type"-->
<!--            label="订阅类型">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="created"-->
<!--            label="订阅时间"-->
<!--            width="180">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
<!--      <div v-if="subscriptionData.total_count > subscriptionData.pageSize" class="content-center content-top-padded"-->
<!--           style="margin-top: 10px">-->
<!--        <el-pagination-->
<!--            background-->
<!--            layout="prev, pager, next"-->
<!--            @current-change="getSubList()"-->
<!--            :current-page.sync="subscriptionData.page"-->
<!--            :total="subscriptionData.total_count" :page-size="subscriptionData.pageSize">-->
<!--        </el-pagination>-->
<!--      </div>-->
<!--    </el-dialog>-->
<!--    <el-dialog title="推送记录" size="tiny" :visible.sync="pushLogDialog"-->
<!--               :close-on-click-modal="false" style="padding:10px 20px">-->
<!--      <el-table-->
<!--          :data="subscriptionPushListData"-->
<!--          style="width: 100%">-->
<!--        <el-table-column-->
<!--            prop="id"-->
<!--            label="id">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="template_name"-->
<!--            label="模板别名">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="template_id"-->
<!--            label="模板id">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="count_succ"-->
<!--            label="触达成功">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="count_err"-->
<!--            label="触达失败">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            prop="created"-->
<!--            label="创建时间"-->
<!--            width="180">-->
<!--        </el-table-column>-->
<!--      </el-table>-->
<!--      <div v-if="subscriptionPushData.total_count > subscriptionPushData.pageSize"-->
<!--           class="content-center content-top-padded" style="margin-top: 10px">-->
<!--        <el-pagination-->
<!--            background-->
<!--            layout="prev, pager, next"-->
<!--            @current-change="getSubList()"-->
<!--            :current-page.sync="subscriptionPushData.page"-->
<!--            :total="subscriptionPushData.total_count" :page-size="subscriptionPushData.pageSize">-->
<!--        </el-pagination>-->
<!--      </div>-->
<!--    </el-dialog>-->
  </div>
</template>
<script>
// import {mapGetters} from 'vuex'
import {
  addWxaMessageTemplate,
  editWxaMessageTemplate,
  getWxaMessageTemplateList,
  // getWxSubscriptionList,
  // getPushLogList,
  sendMsg
} from '@/api/wxa'

export default {
  data () {
    return {
      detailDialog: false,
      addTemplateDialog: false,
      editTemplateDialog: false,
      subscriptionTableDialog: false,
      pushLogDialog: false,
      temlateList: [],
      page: 1,
      pageSize: 20,
      total_count: '',
      appid: 'wx47d38fb07875e1b0',
      rowSubscriptionData: [],
      subscriptionPushListData: [],
      tmpl_type_data: [{
        value: 'timingSend',
        label: '定时发送'
      }, {
        value: 'nowSend',
        label: '即时发送'
      }, {
        value: 'trigger',
        label: '触发式'
      }],
      appid_data: [{
        value: 'wx47d38fb07875e1b0',
        label: '怡康到家'
      }, {
        value: 'wx5fbda51d446ddf0c',
        label: '怡康优选'
      }],
      editTemplate: {
        id: '',
        title: '',
        template_id: '',
        appid: '',
        is_open: false,
        scenes_name: '',
        tmpl_type: '',
        send_time_desc: '',
        content: [],
        page: ''
      },
      addTemplate: {
        title: '',
        template_id: '',
        appid: '',
        is_open: false,
        scenes_name: '',
        tmpl_type: '',
        send_time_desc: '',
        content: [
          {
            'keyName': '',
            'keyValue': ''
          }
        ],
        page: ''
      },
      subscriptionData: {
        page: 1,
        pageSize: 10,
        title: '',
        total_count: 0,
        template_name: '',
        template_id: ''
      },
      subscriptionPushData: {
        page: 1,
        pageSize: 10,
        title: '',
        total_count: 0,
        template_name: '',
        template_id: ''
      }
    }
  },
  computed: {
    // ...mapGetters([
    //   'wxappid',
    //   'template_name'
    // ])
  },
  methods: {
    closeDialog () {
      this.detailDialog = false
      this.addTemplateDialog = false
      this.editTemplateDialog = false
      this.subscriptionTableDialog = false
      this.subscriptionData.page = 1
    },
    addTemplatesDialogVisible () {
      this.addTemplateDialog = true
    },
    editTemplatesDialogVisible (row) {
      this.editTemplateDialog = true
      this.editTemplate.appid = row.appid
      this.editTemplate.id = row.id
      this.editTemplate.title = row.title
      this.editTemplate.template_id = row.template_id
      this.editTemplate.is_open = row.is_open
      this.editTemplate.scenes_name = row.scenes_name
      this.editTemplate.tmpl_type = row.tmpl_type
      this.editTemplate.send_time_desc = row.send_time_desc
      this.editTemplate.content = row.content
      this.editTemplate.page = row.page
    },
    checkData (formData) {
      if (formData.title === '') {
        this.$message({message: '模板名称不能为空', type: 'error'})
        return false
      }
      if (formData.template_id === '') {
        this.$message({message: '模板id不能为空', type: 'error'})
        return false
      }
      if (formData.scenes_name === '') {
        this.$message({message: '别名不能为空建议全英文字母拼写', type: 'error'})
        return false
      }
      if (formData.send_time_desc === '') {
        this.$message({message: '时间不能为空', type: 'error'})
        return false
      }
      return true
    },
    subscriptionTableVisible (row) {
      this.subscriptionTableDialog = true
      this.subscriptionData.template_name = row.title
      this.subscriptionData.template_id = row.template_id
      this.getSubList()
    },
    pushLog () {
      this.pushLogDialog = true
      this.getPushLog()
    },
    addTemplateTag () {
      if (this.addTemplate.content.length > 4) {
        this.$message({message: '最多只能添加5个', type: 'error'})
        return false
      }
      this.addTemplate.content.push({
        'keyName': '',
        'keyValue': ''
      })
    },
    editTemplateTag () {
      if (this.editTemplate.content.length > 4) {
        this.$message({message: '最多只能添加5个', type: 'error'})
        return false
      }
      this.editTemplate.content.push({
        'keyName': '',
        'keyValue': ''
      })
    },
    delAddKeyValue (item) {
      var index = this.addTemplate.content.indexOf(item)
      if (index !== -1) {
        this.addTemplate.content.splice(index, 1)
      }
    },
    delEditKeyValue (item) {
      var index = this.editTemplate.content.indexOf(item)
      if (index !== -1) {
        this.editTemplate.content.splice(index, 1)
      }
    },
    editData () {
      if (this.checkData(this.editTemplate) === false) {
        return false
      }
      let params = this.editTemplate
      params.appid = this.appid
      params.company_id = 1
      editWxaMessageTemplate(params).then(res => {
        this.editTemplateDialog = false
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.reloadList()
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '更新失败'
        })
      })
    },
    submitData () {
      if (this.checkData(this.addTemplate) === false) {
        return false
      }
      let params = this.addTemplate
      params.appid = this.appid
      params.company_id = 1
      addWxaMessageTemplate(params).then(res => {
        this.addTemplateDialog = false
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.clearAddTemplate()
        this.reloadList()
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '添加失败'
        })
      })
    },
    clearAddTemplate () {
      this.addTemplate = {
        title: '',
        template_id: '',
        is_open: false,
        scenes_name: '',
        tmpl_type: '',
        send_time_desc: '',
        content: [
          {
            'keyName': '',
            'keyValue': ''
          }
        ],
        page: ''
      }
    },
    sendMsg (row) {
      sendMsg(row.template_id).then(res => {
        this.$message({
          type: 'success',
          message: res.data.msg
        })
      })
    },
    // getSubList () {
    //   let params = {
    //     'page': this.subscriptionData.page,
    //     'pageSize': this.subscriptionData.pageSize,
    //     'template_id': this.subscriptionData.template_id
    //   }
    //   getWxSubscriptionList(params).then(res => {
    //     this.rowSubscriptionData = res.data.data.list
    //     this.subscriptionData.total_count = res.data.data.total_count
    //   }).catch(error => {
    //     this.$message({
    //       type: 'error',
    //       message: error.message
    //     })
    //   })
    // },
    // getPushLog () {
    //   let params = {
    //     'page': this.subscriptionPushData.page,
    //     'pageSize': this.subscriptionPushData.pageSize
    //     // 'template_id': this.subscriptionPushData.template_id
    //   }
    //   getPushLogList(params).then(res => {
    //     this.subscriptionPushListData = res.data.data.list
    //     this.subscriptionPushData.total_count = res.data.data.total_count
    //   }).catch(error => {
    //     this.$message({
    //       type: 'error',
    //       message: error.message
    //     })
    //   })
    // },
    handleSizeChange (size) {
      this.page = 1
      this.pageSize = size
      this.reloadList()
    },
    handleCurrentChange () {
      this.reloadList()
    },
    reloadList (page) {
      if (page) {
        this.page = page
      }
      getWxaMessageTemplateList({
        appid: this.appid,
        page: this.page,
        pageSize: this.pageSize
      }).then(res => {
        this.temlateList = res.data.data.list
        this.total_count = res.data.data.total_count
      })
    }
  },
  mounted () {
    this.reloadList()
  }
}
</script>
<style scoped type="text/css" lang="scss">
.el-tab-pane {
  min-height: 700px;
}

.message-content {
  button {
    margin-left: 20px;
  }
}


.message-count {
  margin: 0 5px 0 20px;
  font-size: 24px;
  color: #ff5000;
}

.message-template {
  .item {
    display: inline-block;
    width: 210px;
    margin: 0 10px;
    border: 1px solid #dfdfdf;

    &-title {
      padding: 10px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      cursor: pointer;

      i {
        float: right;
        margin-top: 4px;
      }
    }

    &-content {
      height: 140px;
      padding: 20px 10px;
      color: #333;
      font-size: 12px;
    }

    &-footer {
      // border-top: 1px solid #dfdfdf;
      padding: 10px 0;
      text-align: center;

      button {
        width: 50%;

        &:hover {
          border: 1px solid #c4c4c4;
          color: #1f2d3d;
        }
      }
    }

    &:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    }

    &.not-open-sms {
      .item-title {
        background-color: #FF4949;
      }
    }

    &.succ-open-sms {
      .item-title {
        background-color: #13CE66;
      }
    }
  }
}

.message-autograph {
  .el-input {
    width: 240px;
    margin-right: 10px;
  }

  span {
    margin: 0 10px;
  }

  button {
    width: 80px;
  }
}

.tempalteTag {
  width: 40%;
}

.sub_font_style p {
  font-size: 16px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.message-prompt {
  margin-top: 30px;
  padding-left: 20px;

  .prompt {
    &-title {
      margin-bottom: 10px;
      font-size: 18px;
      color: #333;

      span {
        border-left: 3px solid #20A0FF;
        padding-left: 10px;
      }
    }

    &-content {
      padding-left: 8px;
      line-height: 1.6;
      color: #666;

      .item-title {
        margin-bottom: 5px;
      }

      .item-content {
        padding-left: 14px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// messages.vue?30152660